import {
  formatDollarInput,
  handlePaymentAmountInputChange,
  validateInputAndFormatToWholeDollar,
} from "../../../lib/formatting";

import StyledInput from "./StyledInput";
import {
  StyledInputLabelProps,
  StyledInputProps,
  StyledInputValidationProps,
} from "./StyledInput/StyledInput";

const MAX_AMOUNT_LENGTH = 6;

type Props = Omit<StyledInputProps, "value" | "onChange"> & {
  amountCents: string;
  onChange: (v: string) => void;
  clearValidationMessages?: () => void;
} & StyledInputLabelProps &
  StyledInputValidationProps;

export default function CustomAmountInput({
  amountCents,
  onChange,
  clearValidationMessages,
  onBlur,
  onFocus,
  ...props
}: Props) {
  return (
    <StyledInput
      {...props}
      value={amountCents}
      onChange={(e) => {
        const val = e.target.value;
        const wholeDollarInput = validateInputAndFormatToWholeDollar(val);
        if (wholeDollarInput !== null) {
          onChange(`$${wholeDollarInput}`);
        } else {
          onChange(`$${val}`);
        }

        if (clearValidationMessages) {
          clearValidationMessages();
        }
      }}
      onBlur={(e) => {
        const handledChange = handlePaymentAmountInputChange(amountCents);
        if (handledChange) {
          onChange(`$${formatDollarInput(handledChange)}`);
        } else {
          onChange("$0.00");
        }

        onBlur?.(e);
      }}
      onFocus={(e) => {
        validateInputAndFormatToWholeDollar(amountCents);
        onFocus?.(e);
      }}
      maxLength={MAX_AMOUNT_LENGTH}
    />
  );
}
